import actions from '../actions/actionTypes';

export const INITIAL_STATE = {
  data: {},
  loading: false,
  error: null,
  skuInfo: {},
};

const prepareProductDetails = (rawProductData) => {
  const { customization } = rawProductData;

  // Identify status of "In store only" flag
  // According to  provided data payload in https://jira.mynmg.com/browse/OSP-4268
  let inStoreOnly = false;

  if (customization) {
    const { customizationOrder = [], customizationOptions = [] } = customization;
    const findBVDGroup = ({ group }) => group === 'BVD';
    inStoreOnly = customizationOrder.some(findBVDGroup) && customizationOptions.some(findBVDGroup);
  }

  return {
    inStoreOnly,
    ...rawProductData,
  };
};

const productDetails = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.PRODUCT_DETAILS_LOADING:
      return {
        ...INITIAL_STATE,
        loading: true,
      };
    case actions.PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        data: prepareProductDetails(payload),
        loading: false,
        skuInfo: payload.skuInfo || {},
      };
    case actions.PRODUCT_DETAILS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case actions.PRODUCT_DETAILS_SET_SKU_INFO:
      return {
        ...state,
        skuInfo: payload || {},
        loading: false,
      };
    default:
      return state;
  }
};

export default productDetails;
